module.exports = __webpack_public_path__ + "static/media/paris_1701970945294.2891558d.png";